const commonStrings = {
  notFound: {
    title: 'You went off limits here',
    subTitle: 'Choose a tab from the sidebar to continue browsing',
  },
};

export default commonStrings;
